export default {
  methods: {
    //show Error message
    //for the future: Error logging via error logging service
    onError(error, message){
      /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
      console.error(error)
    },

    onSuccess(message){
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/notification.js